"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _utilities = require("@sart/utilities");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _TextInput = _interopRequireDefault(require("./TextInput"));
var _Space = _interopRequireDefault(require("./Space"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _excluded = ["label", "day", "month", "year", "footer", "error", "hideError", "dayPlaceholder", "monthPlaceholder", "yearPlaceholder", "placeholderTextColor", "onDayChange", "onMonthChange", "onYearChange", "onDayBlur", "onMonthBlur", "onYearBlur", "style", "labelStyle", "inputStyle", "errorStyle", "footerErrorStyle", "dayStyle", "monthStyle", "yearStyle"];
function DateTextInputs(props) {
  var label = props.label,
    day = props.day,
    month = props.month,
    year = props.year,
    footer = props.footer,
    error = props.error,
    hideError = props.hideError,
    dayPlaceholder = props.dayPlaceholder,
    monthPlaceholder = props.monthPlaceholder,
    yearPlaceholder = props.yearPlaceholder,
    placeholderTextColor = props.placeholderTextColor,
    onDayChange = props.onDayChange,
    onMonthChange = props.onMonthChange,
    onYearChange = props.onYearChange,
    onDayBlur = props.onDayBlur,
    onMonthBlur = props.onMonthBlur,
    onYearBlur = props.onYearBlur,
    style = props.style,
    labelStyle = props.labelStyle,
    inputStyle = props.inputStyle,
    errorStyle = props.errorStyle,
    footerErrorStyle = props.footerErrorStyle,
    dayStyle = props.dayStyle,
    monthStyle = props.monthStyle,
    yearStyle = props.yearStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var hasDay = day !== undefined && day !== null;
  var hasMonth = month !== undefined && month !== null;
  var hasYear = year !== undefined && year !== null;

  //const evaluatedDate = day && month && year ? new Date(year + "-" + month + "-" + day) : undefined

  // Refs for input fields
  var dayRef = _react["default"].useRef(null);
  var monthRef = _react["default"].useRef(null);
  var yearRef = _react["default"].useRef(null);

  // Handlers to auto-focus next field
  var handleDayChange = function handleDayChange(text) {
    if (onDayChange) onDayChange(text);
    // Only auto-focus if user is entering (not deleting) and length is 2
    if (text.length === 2 && (day === null || day === void 0 ? void 0 : day.length) < text.length && monthRef.current) {
      monthRef.current.focus();
    }
  };
  var handleMonthChange = function handleMonthChange(text) {
    if (onMonthChange) onMonthChange(text);
    // Only auto-focus if user is entering (not deleting) and length is 2
    if (text.length === 2 && (month === null || month === void 0 ? void 0 : month.length) < text.length && yearRef.current) {
      yearRef.current.focus();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, style]
  }, label && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, label), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.wrapper
  }, hasDay && /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
    ref: dayRef,
    style: [dayStyle, error && styles.error, error && errorStyle],
    keyboardType: "numeric",
    maxLength: 2,
    value: day,
    placeholder: dayPlaceholder,
    onChangeText: handleDayChange,
    onBlur: onDayBlur,
    placeholderTextColor: placeholderTextColor,
    returnKeyType: "next",
    onSubmitEditing: function onSubmitEditing() {
      return monthRef.current && monthRef.current.focus();
    }
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "bday-day"
    }
  }), (0, _utilities.testID)('DateDay'), rest)), hasMonth && /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
    ref: monthRef,
    style: [monthStyle, error && styles.error, error && errorStyle],
    keyboardType: "numeric",
    maxLength: 2,
    value: month,
    placeholder: monthPlaceholder,
    onChangeText: handleMonthChange,
    onBlur: onMonthBlur,
    placeholderTextColor: placeholderTextColor,
    returnKeyType: "next",
    onSubmitEditing: function onSubmitEditing() {
      return yearRef.current && yearRef.current.focus();
    }
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "bday-month"
    }
  }), (0, _utilities.testID)('DateMonth'), rest)), hasYear && /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
    ref: yearRef,
    style: [yearStyle, error && styles.error, error && errorStyle],
    keyboardType: "numeric",
    maxLength: 4,
    value: year,
    placeholder: yearPlaceholder,
    onChangeText: onYearChange,
    onBlur: onYearBlur,
    placeholderTextColor: placeholderTextColor
    // returnKeyType="done"
  }, _reactNative.Platform.select({
    web: {
      autoComplete: "bday-year"
    },
    android: {
      returnKeyType: "done"
    }
  }), (0, _utilities.testID)('DateYear'), rest))), (error && !hideError || footer) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), error && !hideError ? /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    style: styles.footerError && footerErrorStyle
  }, error) : footer && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.footer
  }, footer), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  })));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'column'
    // maxWidth: '100%'
  },
  wrapper: {
    // width: '100%',
    flexDirection: 'row'
  },
  error: {
    color: _styles.colors.error,
    borderColor: _styles.colors.error
  },
  day: {},
  month: {},
  year: {},
  label: {},
  input: {
    //...typography.defaultTextStyle,
    //color: colors.common,
    //padding: 12,
    //borderWidth: 2,
    //borderColor: colors.common,
    //borderRadius: 4,
    // fontWeight: '500',
    // color: clear
  },
  footer: {},
  footerError: {
    textAlign: 'left'
  }
});
DateTextInputs.propTypes = {
  hasDay: _propTypes["default"].bool,
  hasMonth: _propTypes["default"].bool,
  hasYear: _propTypes["default"].bool,
  dayValue: _propTypes["default"].string,
  monthValue: _propTypes["default"].string,
  yearValue: _propTypes["default"].string,
  dayPlaceholder: _propTypes["default"].string,
  monthPlaceholder: _propTypes["default"].string,
  yearPlaceholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  onDayChange: _propTypes["default"].func,
  onMonthChange: _propTypes["default"].func,
  onYearChange: _propTypes["default"].func,
  style: _propTypes["default"].any,
  inputStyle: _propTypes["default"].any,
  labelStyle: _propTypes["default"].any
};
var _default = exports["default"] = DateTextInputs;